import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../../constants';
import { MsalProvider } from '@azure/msal-react';
import AzureB2C from './AzureB2C';
import AzureB2CLogout from './AzureB2CLogout';
import logo from 'assets/img/logo-xomePro.png';

const msalInstance = new PublicClientApplication(msalConfig);
// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
          event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
          event.eventType === EventType.SSO_SILENT_SUCCESS) &&
      event.payload.account
  ) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

const AzureB2CProvider = ({ ...props }) => {
  const [comp, setComp] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setComp(1);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      {
        comp == 0
          ? <div className='login-background background-header bg_img'>
            <div className='header-logo'>
              <img className='header-logo-image' src={logo} />
            </div>
            <div className='loader-container'>
              <div className='loader'>
                <div className='spinner' />
                <p>Please wait while we load the page.</p>
              </div>
            </div>
          </div>
          : (props.action === 'logout' ? <AzureB2CLogout /> : <AzureB2C />)
      }

    </MsalProvider>
  );
};

AzureB2CProvider.propTypes = {
  action: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AzureB2CProvider));
